import { useLocation } from '@reach/router';
import { useMemo } from 'react';

import { Languages } from 'modules/Core';
import { ignoreLeadingSlash } from 'utils/string';

const VALID_LANGUAGES = [Languages.EN_US, Languages.PT_BR, Languages.ES_CO];

/**
 * Returns if the current location pathname value
 * matches a given route, without taking into account
 * the current language prefix
 * So /pt-BR/docs matches /docs
 *
 * @param page The page path to be tested against, recommended to use ROUTER_PATHS strings
 * @returns A boolean which is true if the current page matches the argument
 */
export const useIsPageAt = (page: string): boolean => {
  const { pathname } = useLocation();

  return useMemo(() => {
    const withoutLocale = VALID_LANGUAGES.reduce(
      (path, locale) => path.replace(new RegExp(`^/${locale}/`), '/'),
      pathname
    );

    return ignoreLeadingSlash(withoutLocale) === ignoreLeadingSlash(page);
  }, [pathname]);
};
